import React from 'react';
import styles from './ContentTitle.module.css';

const ContentTitle=(props)=>{
	
	//make sure title have to single words at the end of a line
	let title_arr=(props.title || '').split(' '),
		title=(title_arr.length>2)
			?<span>
				{title_arr.slice(0,title_arr.length-2).join(' ')+' '}
				<span className={styles.nobreak}>{title_arr.slice(title_arr.length-2,title_arr.length).join(' ')}</span>
			</span>
			:<span>{title_arr.join(' ')}</span>;

	return(
		<div className={[styles.title_container,props.styles.title_container].join(' ')}>
			{props.title
				?<div className={[styles.title,props.styles.title].join(' ')}>{title}</div>
				:null}
			{props.author
				?<div className={[styles.author,props.styles.author].join(' ')}>{`by ${props.author}`}</div>
				:null}
			{props.published_date
				?<div className={[styles.author,props.styles.author].join(' ')}>{`${props.published_date}`}</div>
				:null}	
		</div>
	);
};

export default ContentTitle;
